import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, withDefaults } from "vue";
import { appContext } from "@/appContext";
import * as dropIn from 'braintree-web-drop-in';
import { Dropin } from 'braintree-web-drop-in';

export interface IPaymentFormData {
  type: 'card' | 'new'
  data: {
    token: string
    method: string
  } | {
    card_id: string
  }
}

interface IUserPaymentCard {
  uuid: string;
  card_brand: string;
  card_last_four_digits: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentMethodWidget',
  props: {
    overUserData: { default: null },
    userCards: { default: () => [] }
  },
  setup(__props: any, { expose }) {

const props = __props as { overUserData: any, userCards: IUserPaymentCard[] };



onMounted(() => {
  createBrainTreeDropInClient();

  console.log(props);
});

function createBrainTreeDropInClient() {
  const googlePay = {
    merchantId: null,
    environment: null,
    transactionInfo: {
      totalPriceStatus: 'NOT_CURRENTLY_KNOWN',
      currencyCode: 'USD'
    },
    cardRequirements: {
      billingAddressRequired: false
    }
  };

  const applePay = {
    displayName: 'BlueCrates LLC',
    paymentRequest: {
      total: {
        label: 'BlueCrates LLC',
        amount: '0',
        type: 'pending'
      }
    }
  };

  if (appContext.APP_ENVIRONMENT() === 'production') {
    googlePay.merchantId = appContext.GOOGLE_MERCHANT_ID() as any;
  } else {
    googlePay.environment = 'TEST' as any;
  }

  let options = {
    container: '#drop-container',
    authorization: brainTreeToken.value,
    customerId: userData.value ? userData.value.braintree : null,
    locale: 'en_US',
    paypal: {
      // TODO: ???
      flow: 'vault'
    },
    googlePay,
    applePay
  };

  dropIn.create(options as any, (error, instance) => {
    if (error) {
      console.error("Braintree error", error);

      braintreeError.value = (error as Error).message;
    } else {
      braintreeInstance.value = instance;
    }
  });
}

let selectedUserCardId = ref<string | null>(null);

let braintreeError = ref('');
let braintreeInstance = ref<Dropin | null | undefined>(null);

let userData = computed<any>(() => {
  return props.overUserData as any;
});

let brainTreeToken = computed(() => {
  return appContext.BRAINTREE_TOKEN();
});

function requestPaymentMethod(): Promise<IPaymentFormData> {
  if (!braintreeInstance.value)
    throw 'Payment gateway is not initialized.';

  return new Promise<IPaymentFormData>((resolve, reject) => {
    if (selectedUserCardId.value) {
      resolve({
        type: "card",
        data: {
          card_id: selectedUserCardId.value
        }
      } as IPaymentFormData);
    } else {
      braintreeInstance.value.requestPaymentMethod({}, (error, payload) => {
        // TODO: Check it
        if (error) {
          reject(error);
        }

        resolve({
          type: "new",
          data: {
            method: payload.method,
            token: payload.nonce
          }
        });
      });
    }
  });
}

expose({
  requestPaymentMethod
});


return { __sfc: true,props, createBrainTreeDropInClient, selectedUserCardId, braintreeError, braintreeInstance, userData, brainTreeToken, requestPaymentMethod }
}

})